import OutdoorDelivery from '@/components/OutdoorDelivery'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		vouchers: [],
		...opts,
		vueComponent: OutdoorDelivery
	}

	let page = vuewidget(dom, options)
	return page
}
